import { render } from "./FormsCharts.html?vue&type=template&id=39322d81&external"
import script from "./FormsCharts.vue?vue&type=script&lang=js"
export * from "./FormsCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__